import { render } from "./simpeg-pensiun-list.vue?vue&type=template&id=2d92e810"
import script from "./simpeg-pensiun-list.vue?vue&type=script&lang=js"
export * from "./simpeg-pensiun-list.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__